import { CoralogixRum } from '@coralogix/browser';
import { CONFIGS } from 'constants/config';
// import { CoralogixLogSeverity } from '@coralogix/browser/src/types-external';

function getVersion() {
	try {
		const last8Digits = process.env.REACT_APP_VERSION.slice(-8); // Extract the last 8 digits
		return last8Digits;
	} catch (error) {
		// Handle errors if needed
		console.error('Something went wrong: ', error);
		return null;
	}
}

if (CONFIGS.CORALOGIX.WHITELISTED_DOMAINS.includes(window.location.origin)) {
	console.log('<=============== Initialising Coralogix ===============>');
	CoralogixRum.init({
		public_key: CONFIGS.CORALOGIX.PUBLIC_KEY,
		application: CONFIGS.CORALOGIX.APPLICATION,
		version: getVersion() || 'v1.0.0',
		coralogixDomain: CONFIGS.CORALOGIX.DOMAIN,
	});
}

/**
 * Following functions can be used to set
 * user contexts and use custom label
 */

// CoralogixRum.setUserContext({
// 	user_id: '123',
// 	user_name: 'name',
// 	user_email: 'user@email.com',
// 	user_metadata: {
// 		role: 'admin',
// 	},
// });

// CoralogixRum.setLabels({
// 	paymentMethod: 'visa',
// 	userTheme: 'black',
// });

/**
 * Dedicated logging can be done with these
 * apart from the traditional console
 * logs and errors
 */
// CoralogixRum.log(CoralogixLogSeverity.Error, 'this is a log', { key: 'value' });
// CoralogixRum.error('this is a log with error severity', { key: 'value' });
